import { connect } from "react-redux";
import { DesignChapter } from "@learningblocks/storybook-components";
import { viewFourDrop, viewFourRemoveStep } from "@learningblocks/exp-redux";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    onDropStep: (params) => dispatch(viewFourDrop(params)),
    onRemoveStep: (params) => dispatch(viewFourRemoveStep(params)),
  };
}

export const GroupE = connect(
  mapStateToProps,
  mapDispatchToProps
)(DesignChapter.GroupE);
